// extracted by mini-css-extract-plugin
module.exports = {"container":"ForInvestors_container__IZ87A","text":"ForInvestors_text__1groX"};